module.exports = __webpack_public_path__ + "static/img/logoFooter.429ced1b.png";